import { cn } from '@/lib/utils';
import { Button, type ButtonProps } from './button';

export function Sheet({ open, onOpenChange, children }: { 
  open: boolean; 
  onOpenChange: (v: boolean) => void; 
  children?: React.ReactNode 
}) {
  if (!open) return null;
  return (
    <>
      <div className="fixed inset-0 z-40 bg-black/50" onClick={() => onOpenChange(false)} />
      <div className="fixed inset-y-0 right-0 z-50 w-80 max-w-full bg-white dark:bg-gray-800 shadow-xl p-6">
        {children}
      </div>
    </>
  );
}

export function SheetContent({ children, className = '' }: { children?: React.ReactNode; className?: string }) {
  return <div className={cn('', className)}>{children}</div>;
}

export function SheetHeader({ children }: { children?: React.ReactNode }) {
  return <div className="mb-4">{children}</div>;
}

export function SheetTitle({ children }: { children?: React.ReactNode }) {
  return <h2 className="text-lg font-semibold">{children}</h2>;
}

export function SheetTrigger({ children, className, ...props }: ButtonProps) {
  return (
    <Button className={className} {...props}>
      {children}
    </Button>
  );
}
